import { createRouter, createWebHistory } from '@ionic/vue-router';


import authenticationService from "./composables/authenticationService";
const auth = authenticationService();


const routes = [
  {
    path: "/",
    name: "startpage",
    redirect: "/dashboard",
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: () => import('@/views/StatisticsPage.vue')
  },
  {
    path: "/orders",
    name: "orders",
    redirect: "/orders/overview",
  },
  {
    path: "/orders/overview",
    name: "orders-overview",
    component: () => import('@/views/DashboardPage.vue')
  },
  {
    path: "/orders/list",
    name: "orders-list",
    component: () => import('@/views/OrdersPage.vue'),
  },
  {
    path: "/orders/open",
    name: "orders-open",
    component: () => import('@/views/OrdersPage.vue')
  },
  {
    path: "/content",
    name: "content",
    component: () => import('@/views/ContentPage.vue')
  },
  {
    path: "/pages/:id/edit",
    name: "content-edit-page",
    component: () => import('@/views/PageEditorPage.vue'),
  },
  {
    path: "/pages/new",
    name: "content-add-page",
    component: () => import('@/views/PageEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/stories/:id/edit",
    name: "content-edit-story",
    component: () => import('@/views/StoryEditorPage.vue'),
  },
  {
    path: "/stories/new",
    name: "content-add-story",
    component: () => import('@/views/StoryEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/menu",
    name: "menu",
    redirect: "/menu/products",
  },
  {
    path: "/menu/categories-tags-courses",
    name: "menu-categories-tags-courses",
    component: () => import('@/views/SettingsCategoriesPage.vue')
  },
  {
    path: "/menu/products",
    name: "menu-products",
    component: () => import('@/views/ProductsPage.vue'),
  },
  {
    path: "/menu/products/:id/edit",
    name: "products-edit-product",
    component: () => import('@/views/CombinedProductEditorPage.vue'),
  },
  {
    path: "/menu/products/new",
    name: "products-add-product",
    component: () => import('@/views/CombinedProductEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/menu/discounts",
    name: "discounts",
    component: () => import('@/views/DiscountsPage.vue')
  },
  {
    path: "/menu/discounts/:id/edit",
    name: "discounts-edit-discount",
    component: () => import('@/views/DiscountEditorPage.vue'),
  },
  {
    path: "/menu/discounts/new",
    name: "discounts-add-discount",
    component: () => import('@/views/DiscountEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/accounts",
    name: "accounts",
    component: () => import('@/views/AccountsPage.vue')
  },
  {
    path: "/accounts/:id/edit",
    name: "accounts-edit-account",
    component: () => import('@/views/AccountEditorPage.vue'),
  },
  {
    path: "/menu/accounts/new",
    name: "accounts-add-account",
    component: () => import('@/views/AccountEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/pointsofsale",
    name: "pointsofsale",
    redirect: "/zones",
  },
  {
    path: "/zones",
    name: "zones",
    component: () => import('@/views/ZonesPage.vue')
  },
  {
    path: "/zones/:id/edit",
    name: "zones-edit-zone",
    component: () => import('@/views/ZoneEditorPage.vue'),
  },
  {
    path: "/zones/new",
    name: "zones-add-zone",
    component: () => import('@/views/ZoneEditorPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/orders/list",
    name: "orders-list",
    component: () => import('@/views/OrdersPage.vue')    
  },

  {
    path: "/settings",
    name: "settings",
    redirect: "/settings/general",

  },
  {
    path: "/settings/general",
    name: "settings-general-settings",
    component: () => import('@/views/SettingsGeneralSettingsPage.vue')
  },
  {
    path: "/settings/banking",
    name: "settings-banking",
    component: () => import('@/views/SettingsBankingPage.vue')
  },
  {
    path: "/settings/api",
    name: "settings-api",
    component: () => import('@/views/SettingsApiSettingsPage.vue')
  },
  {
    path: "/settings/info",
    name: "settings-company-info",
    component: () => import('@/views/SettingsCompanyInfoPage.vue')
  },
  {
    path: "/settings/printers",
    name: "settings-printers",
    component: () => import('@/views/SettingsPrintersPage.vue')
  },
  {
    path: "/settings/printers/:id/edit",
    name: "settings-printers-edit-printer",
    component: () => import('@/views/SettingsPrintersEditPrinterPage.vue'),
  },
  {
    path: "/settings/printers/new",
    name: "settings-printers-add-printer",
    component: () => import('@/views/SettingsPrintersEditPrinterPage.vue'),
    meta: { requiresAuth: true },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/LoginPage.vue"),
  },
  {
    path: "/forgot-password",
    name: "forgot-password",
    component: () => import("@/views/ForgotPassword.vue"),
  },
  {
    path: "/reset-password",
    name: "reset-password",
    component: () => import("@/views/ResetPassword.vue"),
  },
  {
    path: "/registration",
    name: "registration",
    component: () => import("@/views/RegistrationPage.vue"),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyPage.vue')
  },
  {
    path: '/terms-and-conditions',
    name: 'termsAndConditions',
    component: () => import('@/views/TermsAndConditionsPage.vue')
  },
  {
    path: '/notifications',
    name: 'notifications',
    component: () => import('@/views/NotificationsTab.vue')
  },
  {
    path: '/users/:userId',
    name: 'userpage',
    component: () => import('@/views/UserPage.vue')
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/ProfileTab.vue')
  },

]

let baseUrl = typeof process != 'undefined' ? process.env.BASE_URL : ""
baseUrl += "/admin"
const router = createRouter({

  history: createWebHistory(baseUrl),
  routes
})


let allowedForUnAuthenticated = ['login', 'registration', 'forgot-password', 'reset-password', 'privacy', 'termsAndConditions'];

router.beforeEach((to, from, next) => {
  // console.log('router.beforeEach in router',to.name, to);
  if (auth.user.value && (to.name === 'login')) {

    if (to.query && to.query.redirect) {
      next({ path: to.query.redirect, replace: true });
    } else {
      next({ name: "startpage", replace: true });
    }
  } else if (!auth.user.value && (!allowedForUnAuthenticated.includes(to.name))) {
    // console.log('redirect to login',to.name,encodeURIComponent(to.path), to);
    let destination = to.path;
    next({ name: "login", replace: true, query: { redirect: destination } });
  } else {
    next();
  }
})

export default router
